import React from 'react';
import { AdvancedMarker, Map as GoogleMap } from '@vis.gl/react-google-maps';
import {
  googleMapsMapId,
  hasGoogleMapsApiKey,
} from '../maps/GoogleMapsProvider';
import { Incident } from '../../pages/law/incidentsData';
import { getIncidentMarkerColor } from './incidentUi';

type IncidentMapCanvasProps = {
  incidents: Incident[];
  onSelectIncident: (incident: Incident) => void;
};

export function IncidentMapCanvas({ incidents, onSelectIncident }: IncidentMapCanvasProps) {
  if (hasGoogleMapsApiKey) {
    return (
      <div className="map-canvas incident-map-canvas google-map-container">
        <GoogleMap
          defaultCenter={{ lat: 6.435, lng: 3.43 }}
          defaultZoom={13}
          gestureHandling="greedy"
          mapId={googleMapsMapId}
          mapTypeControl={false}
          streetViewControl={false}
        >
          {incidents.map((incident) => (
            <AdvancedMarker
              key={incident.id}
              onClick={() => onSelectIncident(incident)}
              position={{ lat: incident.lat, lng: incident.lng }}
              title={`Open ${incident.id}`}
            >
              <button
                aria-label={`Open ${incident.id}`}
                className="google-incident-marker"
                type="button"
              >
                <span style={{ background: getIncidentMarkerColor(incident.status) }} />
              </button>
            </AdvancedMarker>
          ))}
        </GoogleMap>

        <div className="map-legend">
          <div className="legend-item"><span className="legend-dot red" />Active</div>
          <div className="legend-item"><span className="legend-dot gold" />Acknowledged</div>
          <div className="legend-item"><span className="legend-dot green" />Resolved</div>
        </div>
      </div>
    );
  }

  return (
    <div className="map-canvas incident-map-canvas">
      <div className="map-road incident-road-one" />
      <div className="map-road incident-road-two" />
      <div className="map-label incident-place-vi">Victoria Island</div>
      <div className="map-label incident-place-lekki">Lekki</div>

      {incidents.map((incident, index) => (
        <button
          aria-label={`Open ${incident.id}`}
          className="map-vehicle incident-map-marker"
          key={incident.id}
          onClick={() => onSelectIncident(incident)}
          style={{
            left: `${20 + index * 18}%`,
            top: `${30 + (index % 3) * 15}%`,
          }}
          type="button"
        >
          <span
            className="mv-pulse"
            style={{ background: getIncidentMarkerColor(incident.status) }}
          />
          <span className={`mv-dot ${incident.status === 'active' ? 'danger' : incident.status === 'acknowledged' ? 'warn' : ''}`} />
        </button>
      ))}

      <div className="map-legend">
        <div className="legend-item"><span className="legend-dot red" />Active</div>
        <div className="legend-item"><span className="legend-dot gold" />Acknowledged</div>
        <div className="legend-item"><span className="legend-dot green" />Resolved</div>
      </div>
    </div>
  );
}
